const Play = () => (
  <svg
    width="108px"
    height="108px"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={108} height={108} rx={54} fill="#000" fillOpacity={0.2} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42.469 38.507v30.986L70.269 54l-27.8-15.493Zm-5.5-.425c0-4.006 4.306-6.536 7.805-4.586L73.34 49.414c3.592 2.002 3.592 7.17 0 9.172L44.774 74.504c-3.499 1.95-7.805-.58-7.805-4.586V38.082Z"
      fill="#fff"
    />
    <rect
      x={1}
      y={1}
      width={106}
      height={106}
      rx={53}
      stroke="#000"
      strokeOpacity={0.2}
      strokeWidth={2}
    />
  </svg>
);

export default Play;
